export const OnTimePerformance = {
  banner: {
    id: 'div-gpt-ad-1502743031520-5',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightOntimePerformance_top_728x90',
  },
  bannerMobile: {
    id: 'div-gpt-ad-1502743031520-4',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightOntimePerformance_top_320x100',
  },
  bottom: {
    id: 'div-gpt-ad-1502743031520-2',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightOntimePerformance_second_300x250',
  },
  top: {
    id: 'div-gpt-ad-1502743031520-3',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightOntimePerformance_top_300x250',
  },
};



// WEBPACK FOOTER //
// ./modules/OnTimePerformance/components/ads.js